export default "__VITE_ASSET__D8RhO72c__"